







import { Component, Vue, Watch } from 'vue-property-decorator';
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN';
import './App.less';
import editor from '@/views/Diagram/index';
import '@/assets/icon/iconfont.css';
import '@/layout/css/dark.less';
/**
 *
 */
@Component({
    components: {
        editor,
    },
})
export default class App extends Vue {
    /** */
    private zh_CN = zh_CN;

    /**
     * mounted
     */
    mounted(): void {
        const theme = localStorage.getItem('theme');
        if (theme) {
            this.$store.commit('setTheme', theme);
        } else localStorage.setItem('theme', 'light');
        document.body.className = this.themeClass;
    }

    /**
     * path
     */
    @Watch('$route.path', { immediate: true, deep: true })
    onOption(_nVal: string, _oVal: string): void {
        this.setIES(_nVal.includes('/ies'));
    }
    /**
     * setIES
     */
    setIES(value: boolean): void {
        this.$store.commit('setIESMode', value);
    }

    /**
     * onThemeClass
     */
    @Watch('themeClass')
    onThemeClass(): void {
        document.body.className = this.themeClass;
    }

    /**
     *获取类名
     */
    get themeClass(): string {
        if (this.$store.getters.getTheme === 'dark') {
            return 'could_pss_dark_theme  dark_theme';
        } else {
            return 'light_theme';
        }
    }
}
